export const MIN_PW_LENGTH = 5;

export const MODE_B2B_COMMUNICATION = 'communication';
export const MODE_B2C_FULL_FEATURE = 'full-feature';
